import { render, staticRenderFns } from "./OverviewPanel.vue?vue&type=template&id=59c807fe&"
import script from "./OverviewPanel.vue?vue&type=script&lang=js&"
export * from "./OverviewPanel.vue?vue&type=script&lang=js&"
import style0 from "./OverviewPanel.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports